const businessSubscriptionRoutes = [
  {
    path: '/subscription',
    meta: { title: '标讯订阅' },
    children: [
      {
        path: 'list',
        name: 'SubscriptionList',
        component: () => import('@/views/subscription/subscription-list'),
        meta: {
          layout: 'DefaultLayout',
          title: '标讯订阅',
          inNavbar: true,
          pageType: 'public',
          cache: true,
          routeGroup: '大数据服务'
        }
      },
      {
        path: 'buy',
        name: 'SubscriptionBuy',
        component: () => import('@/views/subscription/subscription-buy'),
        meta: {
          layout: 'DefaultLayout',
          title: '标讯订阅开通'
        }
      },
      {
        path: 'set',
        name: 'SubscriptionSet',
        component: () => import('@/views/subscription/subscription-set'),
        meta: {
          layout: 'DefaultLayout',
          title: '订阅设置'
        }
      }
    ]
  }
]

export default businessSubscriptionRoutes
